<template>
  <div>
    <!-- 기본 -->
    <div
      class="national-congressman-wrap"
      v-if="selectedPage === PAGE_ASSEMBLY.MAIN"
    >
      <span class="national-blue-bar"></span>
      <div class="title-wrap">
        <div
          v-if="isSortingListShow"
          @click="closeSrotingList"
          class="national-search-bg"
        ></div>
        <div class="national-title">22대 국회의원 입법 현황판</div>
        <div class="national-search-wrap">
          <span class="national-search-list">
            <span @click="openSortingList" class="national-search-btn"
              >{{ selectedSortLabel
              }}<img
                class="arrow"
                :src="
                  isSortingListShow
                    ? require('../../assets/img/top-arrow.png')
                    : require('../../assets/img/bottom-arrow.png')
                "
                alt="화살표"
            /></span>
            <ul v-if="isSortingListShow" class="national-search">
              <li
                :class="selectedSortLabel === '기본순' ? 'selected' : ''"
                @click="sortList('BASE', '기본순')"
              >
                기본순<img
                  v-if="selectedSortLabel === '기본순'"
                  class="selected-img"
                  :src="require('../../assets/img/selected.png')"
                  alt="체크아이콘"
                />
              </li>

              <li
                :class="selectedSortLabel === '발의건' ? 'selected' : ''"
                @click="sortList('PROPOSAL', '발의건')"
              >
                발의건<img
                  v-if="selectedSortLabel === '발의건'"
                  class="selected-img"
                  :src="require('../../assets/img/selected.png')"
                  alt="체크아이콘"
                />
              </li>

              <li
                :class="selectedSortLabel === '처리건' ? 'selected' : ''"
                @click="sortList('PROCESSING', '처리건')"
              >
                처리건<img
                  v-if="selectedSortLabel === '처리건'"
                  class="selected-img"
                  :src="require('../../assets/img/selected.png')"
                  alt="체크아이콘"
                />
              </li>
              <li
                :class="selectedSortLabel === '미처리건' ? 'selected' : ''"
                @click="sortList('UN_PROCESSING', '미처리건')"
              >
                미처리건<img
                  v-if="selectedSortLabel === '미처리건'"
                  class="selected-img"
                  :src="require('../../assets/img/selected.png')"
                  alt="체크아이콘"
                />
              </li>
              <li
                :class="selectedSortLabel === '처리율' ? 'selected' : ''"
                @click="sortList('PROCESSING_RATE', '처리율')"
              >
                처리율<img
                  v-if="selectedSortLabel === '처리율'"
                  class="selected-img"
                  :src="require('../../assets/img/selected.png')"
                  alt="체크아이콘"
                />
              </li>
            </ul>
          </span>
          <input
            @keyup="bindEnter"
            v-model="searchInput"
            placeholder="의원명"
            class="search-input"
          />
          <button class="search-btn" @click="search" type="button">
            <img
              :src="require('../../assets/img/search.png')"
              alt="검색아이콘"
            />
          </button>
        </div>
      </div>
      <div style="text-align: left; margin-bottom: 10px">
        업데이트 날짜: {{ updatedAt }} (업데이트 주기: 1시간)
      </div>
      <MobileScroll />
      <br />
      <div
        class="table-wrap"
        :style="
          renderingDataList.length !== originDataList.length
            ? 'margin-bottom: 50px;'
            : 'margin-bottom: 100px;'
        "
      >
        <table class="national-table">
          <tr>
            <th>순번</th>
            <th>의원명</th>
            <th>선수</th>
            <th>소속정당</th>
            <th>지역구</th>
            <th>발의(건)</th>
            <th>처리(건)</th>
            <th>미처리(건)</th>
            <th>처리율(%)</th>
          </tr>
          <tr v-for="(item, index) in renderingDataList" :key="index">
            <!-- 순번 -->
            <td>{{ index + 1 }}</td>
            <!-- 의원명 -->
            <td>
              <a class="link" :href="item.LINK" target="_blank">{{
                item.HG_NM
              }}</a>
            </td>
            <!-- 선수 -->
            <td>{{ item.UNITS ? item.UNITS.split(",").length : 1 }}</td>
            <!-- 소속정당 -->
            <td>{{ item.POLY_NM }}</td>
            <!-- 지역구 -->
            <td>{{ item.ORIG_NM }}</td>
            <!-- 발의건 -->
            <td>{{ item.TOTAL_BILL_CNT }}</td>
            <!-- 처리건 -->
            <td
              class="blue"
              @click="changeProcessOfCongressmanDisplay(item.HG_NM)"
            >
              {{ item.PROC_BILL_CNT }}
            </td>
            <!-- 미처리건 -->
            <td
              class="red"
              @click="changeUnProcessOfCongressmanDisplay(item.HG_NM)"
            >
              {{ item.UNPROC_BILL_CNT }}
            </td>
            <!-- 처리율 -->
            <td>{{ item.PROC_RATE }}%</td>
          </tr>
        </table>
      </div>
      <div
        class="search-btn-rollback-wrap"
        v-if="renderingDataList.length !== originDataList.length"
      >
        <button type="button" class="rollback-btn" @click="rollback">
          <img
            class="pc"
            :src="require('../../assets/img/all-list-icon.png')"
          />
          <img
            width="30"
            class="mobile"
            :src="require('../../assets/img/all-list-icon-m.png')"
          />
          <span>전체 목록 현황판</span>
        </button>
      </div>
    </div>

    <!-- 처리건 누르면 -->
    <CongressmanProcessing
      :processingData="processingData"
      :sectedCongressman="sectedCongressman"
      @prev="selectedPage = PAGE_ASSEMBLY.MAIN"
      v-if="selectedPage === PAGE_ASSEMBLY.PROCESSING"
    />

    <!-- 미처리건 누르면 -->
    <CongressmanUnProcessing
      :processingData="processingData"
      :sectedCongressman="sectedCongressman"
      @prev="selectedPage = PAGE_ASSEMBLY.MAIN"
      v-if="selectedPage === PAGE_ASSEMBLY.UN_PROCESSED"
    />
  </div>
</template>

<script>
import axios from "axios";
import CongressmanProcessing from "./CongressmanProcessing.vue";
import CongressmanUnProcessing from "./CongressmanUnProcessing.vue";
import MobileScroll from "../common/MobileScroll.vue";

export default {
  name: "NThCongressmanAssemblyTable.vue",
  components: { CongressmanProcessing, CongressmanUnProcessing, MobileScroll },
  data() {
    return {
      selectedPage: "MAIN",
      PAGE_ASSEMBLY: {
        MAIN: "MAIN",
        PROCESSING: "PROCESSING",
        UN_PROCESSED: "UN_PROCESSED",
      },
      originDataList: [],
      renderingDataList: [],
      isSortingListShow: false,
      searchInput: "",
      processingData: [],
      sectedCongressman: "",
      selectedSortLabel: "기본순",
      updatedAt: "",
    };
  },

  created() {
    this.getCongressmanStatisticsBiilList();
  },

  methods: {
    async getCongressmanStatisticsBiilList() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_TRAGET_URL + "/assembly/person"
        );

        if (typeof res.data.list !== "undefined") {
          this.updatedAt = res.data.updatedAt;
          this.originDataList = [...res.data.list];
          this.renderingDataList = [...res.data.list];
        }
      } catch (exception) {
        console.error(`[getCongressmanBillData] - exception ${exception}`);
        alert("데이터 요청에 실패했습니다. 하단 이메일로 문의해주세요.");
      }
    },
    openSortingList() {
      this.isSortingListShow = true;
    },
    closeSrotingList() {
      this.isSortingListShow = false;
    },
    sortList(type, label) {
      this.selectedSortLabel = label;
      switch (type) {
        case "PROPOSAL":
          this.renderingDataList.sort((a, b) => {
            return b.TOTAL_BILL_CNT - a.TOTAL_BILL_CNT;
          });
          this.closeSrotingList();
          break;
        case "PROCESSING":
          this.renderingDataList.sort((a, b) => {
            return b.PROC_BILL_CNT - a.PROC_BILL_CNT;
          });
          this.closeSrotingList();
          break;
        case "UN_PROCESSING":
          this.renderingDataList.sort((a, b) => {
            return b.UNPROC_BILL_CNT - a.UNPROC_BILL_CNT;
          });
          this.closeSrotingList();
          break;
        case "PROCESSING_RATE":
          this.renderingDataList.sort((a, b) => {
            return b.PROC_RATE - a.PROC_RATE;
          });
          this.closeSrotingList();
          break;
        default:
          this.renderingDataList = [...this.originDataList];
          this.closeSrotingList();
          break;
      }
    },
    rollback() {
      this.searchInput = "";
      this.search();
    },
    bindEnter(event) {
      if (event.key === "Enter") {
        this.search();
      }
    },
    search() {
      if (this.searchInput.length === 0) {
        this.renderingDataList = [...this.originDataList];
        return;
      }
      this.renderingDataList = this.originDataList.filter((item) => {
        return item.HG_NM.includes(this.searchInput);
      });
    },
    async searchProcessOfCongressman(name, isProcessing) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_TRAGET_URL}/assembly/bill?PROPOSER=${name}`
        );

        if (typeof res.data.list !== "undefined") {
          if (isProcessing) {
            this.processingData = res.data.list
              .filter((item) => {
                return !!item.PROC_RESULT;
              })
              .sort((a, b) => {
                return new Date(b.PROPOSE_DT) - new Date(a.PROPOSE_DT);
              });
          } else {
            this.processingData = res.data.list.filter((item) => {
              return !item.PROC_RESULT;
            });
          }

          this.sectedCongressman = name;
        }
      } catch (exception) {
        console.error(`[searchProcessOfCongressman] - exception ${exception}`);
        alert("데이터 요청에 실패했습니다. 하단 이메일로 문의해주세요.");
      }
    },
    async changeProcessOfCongressmanDisplay(name) {
      await this.searchProcessOfCongressman(name, true);
      this.selectedPage = this.PAGE_ASSEMBLY.PROCESSING;
    },
    async changeUnProcessOfCongressmanDisplay(name) {
      await this.searchProcessOfCongressman(name, false);
      this.selectedPage = this.PAGE_ASSEMBLY.UN_PROCESSED;
    },
  },
};
</script>

<style scoped>
.national-congressman-wrap {
  @media only screen and (max-width: 1040px) {
    text-align: center;
  }
}

.national-blue-bar {
  width: 70px;
  height: 5px;
  display: inline-block;
  background-color: #005aab;
  margin-bottom: 19px;
  border-radius: 0 5px 5px 0;
}

.national-blue-bar.sky {
  background-color: #b0d6f8;
  margin-right: 5px;
}

.national-title {
  font-family: GmarketSansMedium;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #005aab;

  @media only screen and (max-width: 1040px) {
    margin-bottom: 59px;
  }
}

.national-table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border-collapse: collapse;
  overflow: hidden;
  border-radius: 10px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #cacaca;
  min-width: 1000px;

  & th {
    padding: 21px 0;
    border: 1px solid #cacaca;
    background-color: #005aab;
    font-family: GmarketSansMedium;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
  }
  & td {
    width: 11.1%;
    /* a 링크에 padding 5 추가함 */
    padding: 16px 0;
    border: 1px solid #cacaca;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
    vertical-align: middle;
  }

  & tr td.red {
    color: #de0000;
    text-decoration: underline;
    cursor: pointer;
    text-underline-offset: 3px;
  }

  & tr td.blue {
    color: #005aab;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
  }

  @media only screen and (max-width: 1040px) {
    & td:first-of-type {
      width: 5.1%;
    }
    & td:nth-of-type(3) {
      width: 5.1%;
    }
  }
}

.arrow {
  float: right;
  vertical-align: middle;
  margin-top: 4px;

  @media only screen and (max-width: 1040px) {
    margin-right: 9px;
  }
}

.selected {
  color: #005aab;

  @media only screen and (max-width: 1040px) {
    position: relative;
    text-align: left;
  }
}

.selected-img {
  float: right;
  margin-top: 6px;

  @media only screen and (max-width: 1040px) {
    position: absolute;
    right: 1px;
  }
}

.link {
  color: #000;
  width: 100%;
  padding: 5px 0;
  display: inline-block;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
}

.national-table.sub-auto {
  table-layout: fixed;

  & .sky {
    background-color: #e7f4ff;

    & td {
      color: #005aab;
      width: auto !important;
      vertical-align: middle;
    }
  }

  & td {
    width: auto;
    max-width: 10px !important;
    vertical-align: middle;
  }

  & tr td:nth-child(n + 2) {
    width: 100px;
  }

  .not {
    width: auto !important;
  }
}

.search-btn-rollback-wrap {
  text-align: center;
  margin-bottom: 50px;
}

.rollback-btn {
  width: 211px;
  height: 50px;
  padding: 17px 29px 18px 30px;
  border-radius: 10px;
  border: solid 1px #0db2ab;
  background-color: #0db2ab;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: space-around;
  font-size: 16px;

  & img.mobile {
    display: none;
  }

  @media only screen and (max-width: 1040px) {
    & img.pc {
      display: none;
    }

    & img.mobile {
      display: inline-flex;
    }

    & {
      gap: 10px;
      width: 100%;
      justify-content: center;
      border-radius: 0;
      font-size: 20px;
    }
  }
}

.national-search-wrap {
  display: flex;
  width: 557px;
  height: 50px;
  border-radius: 10px;
  background-color: #e5e5e5;

  @media only screen and (max-width: 1040px) {
    margin: 0 30px;
    width: 100%;
    background-color: transparent;
    border-radius: 0;

    & * {
      border-radius: 0;
    }

    & img {
      /* 이거 바끄기 */
      /* position: absolute;
      right: 1px; */
    }

    & .national-search-list {
      padding: 0;
      background-color: #e5e5e5;
    }

    & input {
      background-color: #e5e5e5;
    }

    & .national-search-btn {
      padding: 17px 10px 17px 10px;
      font-size: 12px;
    }

    & .national-search-btn img {
      width: 10px;
    }
  }
}

.title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 49px;

  @media only screen and (max-width: 1040px) {
    flex-direction: column;
  }
}

.national-search-list {
  line-height: 50px;
  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #121212;
  border: solid 1px #d8d8d8;
  padding: 17px 20px 17px 31px;
  border-radius: 10px;
  display: inline-block;
  width: 197px;
  border-right: none;
  position: relative;
  cursor: pointer;

  @media only screen and (max-width: 1040px) {
    min-width: 150px;
    display: inline-block;
    flex-basis: 150px;
  }
}

.search-input {
  width: 280px;
  background-color: transparent;
  border-top: solid 1px #d8d8d8;
  border-bottom: solid 1px #d8d8d8;
  border-left: solid 1px #d8d8d8;
  border-right: none;

  @media only screen and (max-width: 1040px) {
    width: 100%;
  }
}

.search-btn {
  width: 80px;
  height: 50px;
  border: solid 1px #004786;
  background-color: #005aab;
  border-radius: 0 10px 10px 0;

  &::placeholder {
    color: #989898;
    margin-left: 30px;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
}

.national-search {
  list-style: none;
  background-color: #fff;
  position: absolute;
  width: 100%;

  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #121212;
  border: solid 1px #d8d8d8;
  padding: 0 20px 0 31px;
  border-radius: 10px;
  display: inline-block;
  width: 197px;
  top: 49px;
  left: -1px;
  padding-bottom: 19px;
  z-index: 5;

  & li {
    margin-top: 19px;
    cursor: pointer;
    text-align: left;
  }

  & li:hover {
    color: #005aab;
  }

  @media only screen and (max-width: 1040px) {
    width: 150px;
  }
}

.national-search-bg {
  position: absolute;
  z-index: 4;
  width: 100%;
  height: 100%;
  background-color: transparent;
  left: 0;
  top: 0;
}

.national-search-btn {
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  padding: 17px 20px 17px 31px;
  text-align: left;
}

.table-wrap {
  width: 100%;
  margin-bottom: 100px;
  overflow-x: scroll;
  padding: 1px;
}
</style>
